import { render, staticRenderFns } from "./bankCardEdit.vue?vue&type=template&id=0612d225&scoped=true"
import script from "./bankCardEdit.vue?vue&type=script&lang=js"
export * from "./bankCardEdit.vue?vue&type=script&lang=js"
import style0 from "./bankCardEdit.vue?vue&type=style&index=0&id=0612d225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612d225",
  null
  
)

export default component.exports